export interface PolicyEmail {
    toName: string;
    emails: string[];
}